import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';
import { FormData } from '../../utils/formValidation';
import PersonalInfoFields from './PersonalInfoFields';
import PasswordFields from './PasswordFields';
import AdminCodeSection from './AdminCodeSection';

interface PersonalInformationStepProps {
  formData: FormData;
  updateFormData: (field: string, value: string) => void;
}

const PersonalInformationStep: React.FC<PersonalInformationStepProps> = ({ formData, updateFormData }) => {
  useUiLanguage();
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">{uiText("Personal Information")}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <PersonalInfoFields formData={formData} updateFormData={updateFormData} />
        <PasswordFields formData={formData} updateFormData={updateFormData} />
      </div>
      <AdminCodeSection formData={formData} updateFormData={updateFormData} />
    </div>
  );
};

export default PersonalInformationStep;
